import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UnknownAction } from "redux";
import { AppState } from "../../store/types";
import { clearAdvancedFilters, updateFilters, updateSort } from "./actions";
import { HcpLandscapeDispatch, HcpLandscapeState } from "./types";

export const useHcpLandscapeState = (): HcpLandscapeState =>
  useSelector(({ hcpLandscape }: AppState) => {
    return hcpLandscape;
  });

export const useHcpLandscapeDispatch = (): HcpLandscapeDispatch => {
  const dispatch = useDispatch();
  // typescript-fsa Action<T> lacks the index signature required by Redux 5's UnknownAction;
  // as unknown as UnknownAction is an intentional compatibility shim — migrate to RTK createAction to remove it.
  return useMemo(
    (): HcpLandscapeDispatch => ({
      updateFilters: (filters) => dispatch(updateFilters(filters) as unknown as UnknownAction),
      clearAdvancedFilters: () => dispatch(clearAdvancedFilters() as unknown as UnknownAction),
      updateSort: (sort) => dispatch(updateSort(sort) as unknown as UnknownAction),
    }),
    [dispatch],
  );
};
